import apiClient from './index';
import { BuildingInDB, BuildingCreate, BuildingUpdate } from './types';


export type OrphanDevice = {
  id: string;
  name?: string | null;
  serial_number?: string | null;
  system_type?: string | null;
  status?: string | null;
  manufacturer?: string | null;
  dev_eui?: string | null;
  mqtt_topic?: string | null;
  last_seen_at?: string | null;
  latest_reading_value?: number | null;
  latest_reading_ts?: string | null;
  building_id: string;
  building_name?: string | null;
  orphan_apartment_id: string;
};

export type OrphanDevicesResponse = {
  building_id: string;
  building_name?: string | null;
  total: number;
  items: OrphanDevice[];
};

export const buildingsApi = {
  async getBuildings(skip: number = 0, limit: number = 100): Promise<BuildingInDB[]> {
    const response = await apiClient.get<BuildingInDB[]>('/buildings/', {
      params: { skip, limit },
    });
    return response.data;
  },

  async getBuildingsByComplexId(id: string | number): Promise<BuildingInDB[]> {
    const response = await apiClient.get<BuildingInDB[]>(`/buildings/complex/${id}`, {
    });
    return response.data;
  },

  async createBuilding(data: BuildingCreate): Promise<BuildingInDB> {
    const response = await apiClient.post<BuildingInDB>('/buildings/', data);
    return response.data;
  },

  async getBuildingById(buildingId: string): Promise<BuildingInDB> {
    const response = await apiClient.get<BuildingInDB>(`/buildings/${buildingId}`);
    return response.data;
  },

  async updateBuilding(buildingId: string, data: BuildingUpdate): Promise<BuildingInDB> {
    const response = await apiClient.put<BuildingInDB>(`/buildings/${buildingId}`, data);
    return response.data;
  },

  async deleteBuilding(buildingId: string, force: boolean = false): Promise<void> {
    const suffix = force ? "?force=true" : "";
    await apiClient.delete(`/buildings/${buildingId}${suffix}`);
  },

  async getArchivedBuildings(complexId?: string): Promise<BuildingInDB[]> {
    const response = await apiClient.get<BuildingInDB[]>('/buildings/archive/list', {
      params: complexId ? { complex_id: complexId } : undefined,
    });
    return response.data;
  },

  async restoreBuilding(buildingId: string): Promise<BuildingInDB> {
    const response = await apiClient.post<BuildingInDB>(`/buildings/${buildingId}/restore`);
    return response.data;
  },

  async getOrphanDevices(buildingId: string): Promise<OrphanDevicesResponse> {
    const response = await apiClient.get<OrphanDevicesResponse>(
      `/buildings/${buildingId}/orphan-devices`
    );
    return response.data;
  },
};
